import { render, staticRenderFns } from "./NetellerWithdraw.vue?vue&type=template&id=68ca955c&scoped=true"
import script from "./NetellerWithdraw.vue?vue&type=script&lang=js"
export * from "./NetellerWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ca955c",
  null
  
)

export default component.exports